export default __webpack_public_path__ + "static/media/why_this_organize.e487c82c.pdf";